import React from 'react'
import TrustBadges from '../sub-components/trust-badges-editor/TrustBadgesEditor'
import OrderSummaryEditor from '../sub-components/OrderSummaryEditor'
import { useCustomizeUI } from 'src/lib/access-permission-hooks/useCustomizeUI'
import { useCustomizeUIContext } from 'src/lib/contexts/CustomizeUIProvider'
import { CustomizeUIPageContextType } from 'src/lib/types/customizeUI'
import AddressConfirmationEditor from '../sub-components/DelhiveryConfimationEditor'

const ElementsTab: React.FC<{}> = () => {
  const { canEditCheckoutCoreSetup } = useCustomizeUI()
  const pageContext = useCustomizeUIContext(context => context.state.pageContext)
  const isOnePageCheckoutEnable = useCustomizeUIContext(context => context.state.orderSummaryConfig.isOnePageCheckoutEnable)
  return (
    <div className='w-full flex flex-col space-y-3'>
      {pageContext === CustomizeUIPageContextType.CUSTOMIZE_UI && (
        <>
          <OrderSummaryEditor type='ONE_PAGE_CHECKOUT' canEdit={canEditCheckoutCoreSetup} />
          <OrderSummaryEditor type='PRICE_STRIKE_THROUGH' canEdit={canEditCheckoutCoreSetup} />
          {isOnePageCheckoutEnable && (
            <>
            <AddressConfirmationEditor canEdit={canEditCheckoutCoreSetup} />
            </>
          )}
        </>
      )}
      <OrderSummaryEditor type='ORDER_SUMMARY' canEdit={canEditCheckoutCoreSetup} />
      <div id='exit-nudge'>
        <OrderSummaryEditor type='EXIT_COUPON' canEdit={canEditCheckoutCoreSetup} />
      </div>
      <TrustBadges canEdit={canEditCheckoutCoreSetup} />
    </div>
  )
}

export default ElementsTab
